import { CloseAction, DmBriefCloseReason } from '../types';

export const getCloseAction = ({ offersCount, hiredCount }: { offersCount: number; hiredCount: number }) => {
    if (offersCount === 0) {
        return CloseAction.DELETE_BRIEF;
    }
    if (offersCount > 0 && hiredCount === 0) {
        return CloseAction.SET_TO_INACTIVE;
    }

    if (offersCount > 0 && hiredCount > 0) {
        return CloseAction.MARK_AS_DONE;
    }

    return CloseAction.DELETE_BRIEF;
};

export const getCloseReasonForAction = (closeAction: CloseAction): DmBriefCloseReason | undefined => {
    switch (closeAction) {
        case CloseAction.DELETE_BRIEF:
            return DmBriefCloseReason.DELETED_BRIEF;
        case CloseAction.MARK_AS_DONE:
            return DmBriefCloseReason.ALREADY_HIRED_BRIEF;
        default:
            return undefined;
    }
};
